import { useState, useEffect, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { CalendarDays, GanttChart, Layers, Loader2 } from "lucide-react";

const GanttPage = lazy(() => import("./planificacion/GanttPage"));
const HeatmapPage = lazy(() => import("./planificacion/HeatmapPage"));
const CalendarPage = lazy(() => import("./planificacion/CalendarPage"));

export default function PlanificacionPage() {
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") || "gantt");
  useEffect(() => {
    if (tab !== params.get("tab")) setParams({ tab }, { replace: true });
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-6 space-y-4" data-testid="planificacion-page">
      <div className="border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Planificación</div>
        <h1 className="text-2xl font-bold tracking-tight">Planificación &amp; Vistas</h1>
        <p className="text-sm text-muted-foreground mt-1">Diagrama Gantt · Heatmap de cargas · Calendario.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="gantt" data-testid="plan-tab-gantt"><GanttChart className="w-4 h-4 mr-2" />Gantt</TabsTrigger>
          <TabsTrigger value="heatmap" data-testid="plan-tab-heatmap"><Layers className="w-4 h-4 mr-2" />Heatmap</TabsTrigger>
          <TabsTrigger value="calendario" data-testid="plan-tab-calendario"><CalendarDays className="w-4 h-4 mr-2" />Calendario</TabsTrigger>
        </TabsList>

        <div className="-mx-6 -mt-2">
          <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
            <TabsContent value="gantt" className="mt-0"><GanttPage /></TabsContent>
            <TabsContent value="heatmap" className="mt-0"><HeatmapPage /></TabsContent>
            <TabsContent value="calendario" className="mt-0"><CalendarPage /></TabsContent>
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
